import { render, staticRenderFns } from "./step.vue?vue&type=template&id=5b5d1190&scoped=true"
import script from "./step.vue?vue&type=script&lang=js"
export * from "./step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5d1190",
  null
  
)

export default component.exports